import { render } from "./LegacyProjectUserPledges.vue?vue&type=template&id=1975c544"
import script from "./LegacyProjectUserPledges.vue?vue&type=script&lang=js"
export * from "./LegacyProjectUserPledges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__